import { styled } from 'styled-components';
const handleAlignment = ({
  $alignment,
  $direction
}) => {
  if ($direction === 'column') {
    return {
      left: 'align-items: flex-start',
      center: 'align-items: center',
      right: 'align-items: flex-end',
      fill: 'align-items: stretch; .aui-action-flat { align-self: center; }',
      'space-between': 'align-items: flex-start'
    }[$alignment];
  } else if ($direction === 'row') {
    return {
      left: 'justify-content: flex-start',
      center: 'justify-content: center',
      right: 'flex-direction: row-reverse',
      fill: '> :not(.aui-action-flat) { flex-grow: 1; } .aui-action-flat { flex-grow: 0; }',
      'space-between': 'justify-content: space-between'
    }[$alignment];
  }
};
export const StyledActionGroup = styled.div.withConfig({
  componentId: "aui__sc-6o6asv-0"
})(["display:flex;flex-wrap:wrap;width:100%;flex-direction:", ";column-gap:var(--aui-spacing-200);row-gap:var(--aui-spacing-075);", ";"], p => p.$direction, handleAlignment);